import React, { useState, useEffect } from 'react'
import App from './App'
import { showFlashMessage } from '../helpers/utils'
import Loader from './shared/Loader'

export default function MyAccount({ appProps, tenantRef, screenClass, logoutPath, hasEnabled2FA }) {
  const [enabled2FA, setEnabled2FA] = useState(hasEnabled2FA)
  const [toggleAction, setToggleAction] = useState(false)
  const [qrcodeSvg, setQrcodeSvg] = useState(null)
  const [code, setCode] = useState('')
  const [qrLoading, setQrLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)

  useEffect(() => {
    if(toggleAction && !enabled2FA) {
      getNewQrcode()
    }
  }, [toggleAction])

  function getNewQrcode() {
    setQrLoading(true)

    Rails.ajax({
      type: 'POST',
      url: '/get_qrcode',
      dataType: 'json',
      success: res => {
        if(res.qrcodeSvg) {
          setQrcodeSvg(res.qrcodeSvg)
        }
      },
      error: res => {

      },
      complete: res => {
        setQrLoading(false)
      }
    })
  }

  function render2FASection() {
    return (
      <div className='section-2fa'>
        <div>
          <b>{Cas.translations.tfa_title}</b>&nbsp;
          {enabled2FA ? Cas.translations.tfa_enabled_status : Cas.translations.tfa_disabled_status}
        </div>

        <div className='flex-box flex-column'>
          <div className='description-2fa'>
            {Cas.translations.tfa_description}
          </div>

          <div className='flex-box apps'>
            <a href='https://apps.apple.com/us/app/google-authenticator/id388497605' target='_blank'>
              <img src='https://storage.googleapis.com/reactive_files_eu/apple_store_icon' width='30' />
            </a>
            <a href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2' target='_blank'>
              <img src='https://storage.googleapis.com/reactive_files_eu/play_store_icon' width='30' />
            </a>
          </div>
        </div>

        <button className='button enable-2fa' onClick={() => setToggleAction(true)}>
          <i className='fa-solid fa-lock'></i>
          {enabled2FA ? Cas.translations.tfa_disable_btn : Cas.translations.tfa_enable_btn}
        </button>
      </div>
    )
  }

  function render2FAEnableForm() {
    return (
      <div className='form-2fa flex-box flex-column'>
        <div>{Cas.translations.tfa_start_scan}</div>

        { qrLoading ?
          <div className='qrcode-loader self-center'>
            <Loader size={'small'} position={'centered'} />
          </div>
          : <div className='qr-code self-center' dangerouslySetInnerHTML={{__html: qrcodeSvg}}></div>
        }

        <div>{Cas.translations.tfa_enable}</div>

        <div className='flex-box items-center code-input'>
          <div>{Cas.translations.tfa_code}:</div>
          <input type='text' value={code} onChange={e => setCode(e.target.value)} />
        </div>

        { submitLoading ?
          <div className='submit-loader self-end'>
            <Loader size={'small'} position={'centered'} />
          </div>
          :
          <button className='button submit-code self-end' onClick={submitCode}>
            {Cas.translations.tfa_submit_code_enable}
          </button>
        }
      </div>
    )
  }

  function render2FADisableForm() {
    return (
      <div className='form-2fa flex-box flex-column'>
        <div>{Cas.translations.tfa_disable}</div>

        <div className='flex-box items-center code-input'>
          <div>{Cas.translations.tfa_code}:</div>
          <input type='text' value={code} onChange={e => setCode(e.target.value)} />
        </div>

        { submitLoading ?
          <div className='submit-loader self-end'>
            <Loader size={'small'} position={'centered'} />
          </div>
          :
          <button className='button submit-code self-end' onClick={submitCode}>
            { Cas.translations.tfa_submit_code_disable }
          </button>
        }
      </div>
    )
  }

  function submitCode() {
    if(code.length === 0) {
      showFlashMessage(`${Cas.translations.tfa_code_blank}`, 'error')
    } else {
      setSubmitLoading(true)

      let formData = new FormData()
      formData.append('tfa[code]', code)

      Rails.ajax({
        type: 'PATCH',
        url: '/update_security',
        dataType: 'json',
        data: formData,
        success: res => {
          setEnabled2FA(res.hasEnabled2FA)
          setToggleAction(false)
          setQrcodeSvg(null)
          setCode('')
          showFlashMessage(Cas.translations.action_saved, 'success')
        },
        error: res => {
          showFlashMessage(Cas.translations.tfa_code_invalid, 'error')
        },
        complete: res => {
          setSubmitLoading(false)
        }
      })
    }
  }

  return (
    <App appProps={ appProps }>
      <div className={ screenClass }>
        <div className='account-profile main-container'>

          <div className='fields-wrapper'>
            {render2FASection()}

            {!enabled2FA && toggleAction && render2FAEnableForm()}
            {enabled2FA && toggleAction && render2FADisableForm()}
          </div>
        </div>
      </div>
    </App>
  )
}
